/* eslint-disable @typescript-eslint/no-namespace */
import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum FinraBrokerCheckBrokerType {
  Individual = 'individual',
  Firm = 'firm',
}

export enum FinraBrokerCheckBrokerStatus {
  Active = 'active',
  Inactive = 'inactive',
  NotInScope = 'not_in_scope',
}

export interface FinraBrokerCheckAddress {
  'street-1'?: string;
  'street-2'?: string;
  city?: string;
  subdivision?: string;
  'postal-code'?: string;
}

export interface FinraBrokerCheckEmployment {
  'crd-number'?: string;
  'broker-dealer-sec-number'?: string;
  'broker-dealer-full-sec-number'?: string;
  name?: string;
  'branch-address'?: FinraBrokerCheckAddress;
}

export interface FinraBrokerCheckResultIndividual {
  'crd-number'?: string;
  'name-first'?: string;
  'name-last'?: string;
  'other-names'?: string[];
  'broker-status'?: FinraBrokerCheckBrokerStatus;
  'investment-advisor-status'?: FinraBrokerCheckBrokerStatus;
  'has-disclosure-filings'?: boolean;
  'approved-finra-registration-count'?: number;
  'employments-count'?: number;
  'start-date'?: string;
  'current-employments'?: FinraBrokerCheckEmployment[];
}

export interface FinraBrokerCheckResultFirm {
  'crd-number'?: string;
  name?: string;
  'other-names'?: string[];
  status?: FinraBrokerCheckBrokerStatus;
  'office-address'?: FinraBrokerCheckAddress;
  'mailing-address'?: FinraBrokerCheckAddress;
  'phone-number'?: string;
  'broker-dealer-sec-number'?: string;
  'broker-dealer-full-sec-number'?: string;
  'has-disclosure-filings'?: boolean;
  'approved-finra-registration-count'?: number;
  'branches-count'?: number;
}

export interface ReportFinraBrokerCheckAttributes extends ReportAttributes {
  'reference-id'?: string;
  'broker-type'?: FinraBrokerCheckBrokerType;
  'crd-number'?: string;
  'name-full'?: string;
  'firm-name'?: string;
  'address-city'?: string;
  'address-subdivision'?: string;
  result?: (FinraBrokerCheckResultIndividual | FinraBrokerCheckResultFirm)[];
}

export type ReportFinraBrokerCheck = ApiResource<
  ReportFinraBrokerCheckAttributes,
  ReportRelationships,
  ApiModel.ReportFinraBrokerCheck
>;
